module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-04-food-table.affe33fc.png";